import { forwardRef, type HTMLAttributes } from 'react';

import { cn } from '../../../utils';
import { RippleRoot } from '../../RippleRoot';

export const FilterChipTriggerTitle = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, children, ...props }, ref) => {
  return (
    <div
      className={cn(
        'text-xs font-normal px-2.5 py-1.5 relative overflow-hidden flex flex-row items-center gap-2 shrink-0',
        'hover:bg-secondary-accent transition-colors',
        className,
      )}
      {...props}
      ref={ref}
    >
      {children}
      <RippleRoot className="bg-secondary-foreground" pulseOpacity={0.2} />
    </div>
  );
});

FilterChipTriggerTitle.displayName = 'FilterChipTriggerTitle';
